module.exports.apiPort = 9001;
module.exports.refreshInterval = 5000;
module.exports.refreshIntervalTooSlow = 300000;
module.exports.panelNameTrippingCurrentCharacteristic = '12 Station Test of Tripping Current Characteristic';
module.exports.panelNameInstantaneousTripping = 'Test of Instantaneous Tripping';
module.exports.panelNameTemperatureRise = 'Temperature Rise & Power Loss Test Bench';
module.exports.panelNameEndurance = '3 Phase MCB & RCCB Endurance Test Bench';
module.exports.panelName28Days = '28 Days & Temperature Rise Test Bench';
module.exports.panelNameMcbCharacteristic = 'Thermal & Magnetic Trip Characteristic Test Bench';
module.exports.panelNameRccb = 'RCCB Type Test as per IEC 61008-1';
module.exports.panelNameTrippingCurrentCharacteristicShort = '12 Stn Tripping Current Characteristic';
module.exports.panelNameInstantaneousTrippingShort = 'Instantaneous Tripping';
module.exports.panelNameTemperatureRiseShort = 'Temperature Rise & Power Loss';
module.exports.panelNameEnduranceShort = 'MCB & RCCB Endurance';
module.exports.panelName28DaysShort = '28 Days & Temperature Rise';
module.exports.panelNameMcbCharacteristicShort = 'Thermal & Magnetic Trip Characteristic';
module.exports.panelNameRccbShort = 'RCCB Type Test';


